import { useEffect, useCallback } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '2681278382272304'

export function useMetaPixel() {
  useEffect(() => {
    // Initialize Pixel only once
    if (typeof window !== 'undefined' && !window.fbq) {
      // Set up fbq function queue before loading the script
      const n: any = (window.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!window._fbq) window._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      // Load the FB pixel script via head append (safe in all environments)
      const scriptEl = document.createElement('script')
      scriptEl.async = true
      scriptEl.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(scriptEl)

      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    }
  }, [])

  const trackCheckout = useCallback(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout')
    }
  }, [])

  return { trackCheckout }
}
